import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mediaHttp } from '@/lib/api/http-client';
import { MEDIA_CAMPAIGN_QUERY_KEYS } from './query-keys';

/**
 * Binds a row to the object on the platform that already carries its name, so
 * publishing changes that one rather than making a second.
 *
 * Sends no id. The server resolves the match again from the row, because an id in a
 * request is an instruction to edit an arbitrary object on a live ad account — which is
 * the accident this whole flow exists to prevent.
 */
export function useLinkNodeToExisting(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (nodeId: string) => {
      await mediaHttp.post({
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: `/api/v1/delivery-jobs/${jobId}/nodes/${nodeId}/link`,
      });
    },
    // The row's state, its findings and the plan's counts all move together.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MEDIA_CAMPAIGN_QUERY_KEYS.all }),
  });
}
